<!-- Topbar Navbar -->
<ul class="navbar-nav ml-auto">
  <li class="nav-item no-arrow mx-1">
    <a href="#" class="nav-link" (click)="toggleFullScreen()">
      <i class="fas fa-expand"></i>
    </a>
  </li>

  <li class="nav-item no-arrow mx-1">
    <a routerLink="/help" class="nav-link">
      <i class="fas fa-question-circle"></i>
    </a>
  </li>

  <!-- Language -->
  <li class="nav-item dropdown no-arrow mx-1">
    <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
      <span class="flag-icon flag-icon-vn"></span>
      <!-- <span *ngIf="sysLang == 'AR'" class="flag-icon flag-icon-ae"></span>
      <span *ngIf="sysLang == 'HN'" class="flag-icon flag-icon-in"></span>
      <span *ngIf="sysLang == 'BN'" class="flag-icon flag-icon-bd"></span> -->
      <span class="badge badge-danger badge-counter">4</span>
    </a>

    <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in">
      <h6 class="dropdown-header">Ngôn ngữ</h6>

      <a (click)="changeLang('EN')" class="dropdown-item d-flex align-items-center" style="cursor: pointer;">
        <div class="mr-3"><span class="flag-icon flag-icon-vn"></span></div>
        <div><span class="font-weight-bold">Tiếng Anh</span></div>
      </a>

      <a (click)="changeLang('AR')" class="dropdown-item d-flex align-items-center">
        <div class="mr-3"><span class="flag-icon flag-icon-ae"></span></div>
        <div><span class="font-weight-bold">Tiếng Ả Rập</span></div>
      </a>

      <a (click)="changeLang('HN')" class="dropdown-item d-flex align-items-center">
        <div class="mr-3"><span class="flag-icon flag-icon-in"></span></div>
        <div><span class="font-weight-bold">Tiếng Hindi</span></div>
      </a>

      <a (click)="changeLang('BN')" class="dropdown-item d-flex align-items-center">
        <div class="mr-3"><span class="flag-icon flag-icon-bd"></span></div>
        <div><span class="font-weight-bold">Tiếng Bengali</span></div>
      </a>
    </div>
  </li>

  <!-- Notifications -->
  <li class="nav-item dropdown no-arrow mx-1">
    <a (click)="onNotificationClick()" class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
      <i class="fas fa-bell fa-fw"></i>
      <span class="badge badge-danger badge-counter">{{ notifications.length }}+</span>
    </a>

    <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in">
      <h6 class="dropdown-header">Thông báo</h6>

      <div class="notification-scroll">
        <ng-container *ngFor="let notification of notifications">
          <a class="dropdown-item d-flex align-items-center">
            <div class="mr-3">
              <div class="icon-circle"
                [ngClass]="{
                  'bg-primary': notification.type === 'info',
                  'bg-success': notification.type === 'success',
                  'bg-warning': notification.type === 'warning',
                  'bg-danger': notification.type === 'error'
                }">
                <i [ngClass]="{
                  'fa fa-info-circle text-white': notification.type === 'info',
                  'fas fa-check-circle text-white': notification.type === 'success',
                  'fa fa-exclamation-circle text-white': notification.type === 'warning',
                  'fa fa-times text-white': notification.type === 'error'
                }"></i>
              </div>
            </div>
            <div>
              <div class="small text-gray-500">{{ notification.date | date: 'short' }}</div>
              <span class="font-weight-bold">{{ notification.content }}</span>
            </div>
          </a>
        </ng-container>
      </div>

      <a class="dropdown-item text-center small text-gray-500">
        Xem tất cả thông báo
      </a>
    </div>
  </li>

  <!-- Search -->
  <li class="nav-item dropdown no-arrow d-sm-none">
    <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
      <i class="fas fa-search fa-fw"></i>
    </a>

    <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in">
      <form class="form-inline mr-auto w-100 navbar-search">
        <div class="input-group">
          <input
            type="text"
            class="form-control bg-light border-0 small"
            placeholder="Tìm kiếm sách, tác giả, danh mục, nhà xuất bản"
          />
          <div class="input-group-append">
            <button class="btn btn-primary" type="button">
              <i class="fas fa-search fa-sm"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </li>

  <div class="topbar-divider d-none d-sm-block"></div>

  <!-- User -->
  <li class="nav-item dropdown no-arrow">
    <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
      <span class="mr-2 d-none d-lg-inline text-gray-600 small">
        {{
          (userObject?.firstName ? userObject.firstName.charAt(0).toUpperCase() + userObject.firstName.slice(1).toLowerCase() : '') +
          ' ' +
          (userObject?.lastName ? userObject.lastName.charAt(0).toUpperCase() + userObject.lastName.slice(1).toLowerCase() : '')
        }}
      </span>
      <img class="img-profile rounded-circle" [src]="retrievedImage" />
    </a>

    <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in">

      <a routerLink="/profile" class="dropdown-item">
        <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
        Hồ sơ của tôi
      </a>

      <a (click)="openProfilePhotoDialog()" class="dropdown-item">
        <i class="fas fa-camera fa-sm fa-fw mr-2 text-gray-400"></i>
        Đổi ảnh đại diện
      </a>

      <a (click)="openLogoDialog()" class="dropdown-item">
        <i class="fas fa-id-card fa-sm fa-fw mr-2 text-gray-400"></i>
        Đổi logo
      </a>

      <a (click)="openPasswordDialog()" class="dropdown-item">
        <i class="fas fa-key fa-sm fa-fw mr-2 text-gray-400"></i>
        Đổi mật khẩu
      </a>

      <a routerLink="/settings" class="dropdown-item">
        <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
        Cài đặt
      </a>

      <div class="dropdown-divider"></div>

      <a routerLink="/" (click)="logout()" class="dropdown-item">
        <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
        Đăng xuất
      </a>
    </div>
  </li>
</ul>